export default __webpack_public_path__ + "static/landing-page-6f8d7a3604c69852ea31b40cc7848ee6.png";